import {createGlobalStyle} from 'styled-components'

import sequel45 from '../fonts/brandfont-sequel100wide/Sequel-100-Wide-45.ttf'
import sequel55 from '../fonts/brandfont-sequel100wide/Sequel-100-Wide-55.ttf'
import sequel65 from '../fonts/brandfont-sequel100wide/Sequel-100-Wide-65.ttf'
import sequel75 from '../fonts/brandfont-sequel100wide/Sequel-100-Wide-75.ttf'
import sequel85 from '../fonts/brandfont-sequel100wide/Sequel-100-Wide-85.ttf'

const screen_size = {
    mobile: "1200px",
    desktop: "1200px",
    small_height_desktop: "700px",
}

export const theme = {
    fonts: {
        sequel45: "Sequel45",
        sequel55: "Sequel55",
        sequel65: "Sequel65",
        sequel75: "Sequel75",
        sequel85: "Sequel85",
    },
    colors: {
        primary: "#0C2637",
        secondary: "#3B869D",
        tertiary: "#564E9C",
        white: "#FFF",
        black: "rgba(0, 0, 0, 1)",
    },
    breakpoints: {
        mobile: `only screen and (max-width: ${screen_size.mobile})`,
        mobile_reverse: `only screen and (min-width: ${screen_size.mobile})`,
        small_height: `only screen and (max-height: ${screen_size.small_height_desktop}) and (min-width: 1200px), (min-width: 1900px)`,
        thinkpad: `only screen and (max-height: ${screen_size.small_height_desktop})`,
        // large_header_reverse: "only screen and (max-width: 1035px)",
        // medium_header: "only screen and (min-width: 800px)",
        // medium_header_reverse: "only screen and (max-width: 800px)",
    },
    sizes: {
        header: '9rem',
    },
    spacings: {
        xxSmall: ".25rem",
        xSmall: ".5rem",
        small: "1rem",
        xxmedium: "1.5rem",
        xmedium: "1.75rem",
        medium: "2rem",
        large: "3rem",
        xLarge: "4rem",
        xxLarge: "6rem",
        xxxLarge: "6.25rem",
    },
    animations: {
        link: "all 0.3s linear",
    },
    icons: {},
}

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Sequel45';
    src: url(${sequel45});
  }
  @font-face {
    font-family: 'Sequel55';
    src: url(${sequel55});
  }
  @font-face {
    font-family: 'Sequel65';
    src: url(${sequel65});
  }
  @font-face {
    font-family: 'Sequel75';
    src: url(${sequel75});
  }
    @font-face {
    font-family: 'Sequel85';
    src: url(${sequel85});
  }
  
  html {
    font-size: 62.5%;
    @media ${theme.breakpoints.thinkpad} {
        font-size: 45%;
    }
  }
  
  
    .modal-stay-updated {
        outline: none;
        inset: 45% auto auto 50%;
        margin-right: -50%;
        transform: translate(0%, 0%);
        max-width: 65%;
        padding: 0px;
        border-radius: 2px;
        height: auto !important;
        position: absolute;
        background: white;
        
        @media ${theme.breakpoints.mobile} {
            max-width: 90% !important;
            top: 45% !important;
        }
    }
  
    .modal-safe-recreation {
        outline: none;
        inset: 50% auto auto 50%;
        margin-right: -50%;
        transform: translate(-50%, -50%);
        max-width: 800px;
        padding: 0px;
        border-radius: 2px;
        height: unset;
        position: absolute;
        background: white;
        overflow-y: scroll !important;
        @media ${theme.breakpoints.mobile} {
            height: 80% !important;
        }    
    }
    
    .modal-safe-leader {
        outline: none;
        inset: 50% auto auto 50%;
        margin-right: -50%;
        transform: translate(-50%, -50%);
        max-width: 800px;
        padding: 0px;
        border-radius: 2px;
        height: unset;
        position: absolute;
        background: white;
        overflow-y: scroll !important;
        @media ${theme.breakpoints.mobile} {
            height: 90% !important;
            max-width: 92% !important;
        }  
    }
    
    

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    scroll-behavior: smooth;
    color: ${theme.colors.primary};
    background-color: white;
    font-family: ${theme.fonts.sequel75};
    font-family: Sequel75;
    font-style: normal;
    font-weight: 400;
  }
  
  h3 {
    font-family: ${theme.fonts.sequel75};
    line-height: 4.4rem;
    font-size: 3.2rem;
    @media ${theme.breakpoints.mobile} {
        font-family: ${theme.fonts.sequel45};
        line-height: 2.4rem;
        font-size: 1.8rem;
    }
  }
  
  h4 {
    font-family: ${theme.fonts.sequel55};
    line-height: 3rem;
    font-size: 2.2rem;
    @media ${theme.breakpoints.mobile} {
        font-family: ${theme.fonts.sequel55};
        line-height: 3rem;
        font-size: 2.2rem;
    }
  }

  h1 {
    line-height: 5.7rem;
    font-size: 4.2rem;
    font-family: ${theme.fonts.sequel85};
    @media ${theme.breakpoints.mobile} {
        font-family: ${theme.fonts.sequel75};
        font-size: 2.0rem;
        line-height: 2.7rem;
    }
  }
  
  h2 {
    line-height: 5.7rem;
    font-size: 4.2rem;
    font-family: ${theme.fonts.sequel85};
    @media ${theme.breakpoints.mobile} {
        font-family: ${theme.fonts.sequel75};
        font-size: 2.0rem;
        line-height: 2.7rem;
    }
  }

  a {
    color: ${theme.colors.primary};
    text-decoration: none;
    font-size: 1.8rem;
  }

  button {
    border: none;
  }

  p {
    font-weight: 400;
    font-size: 1.6rem;
    line-height: 2.2rem;
    font-family: ${theme.fonts.sequel55};
  }
`
